var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 466.842,
    height: 598.161,
    viewBox: "0 0 466.842 598.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-20.4 -1.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M99.125,387.92Q45.558,320.606,45.4,237.807q0-87.7,61.626-149.481Q167.7,28.122,253.663,26.7q85.8.948,146.953,61.626,61.626,61.626,61.626,149.481,0,82.957-54.041,150.113l-80.271,96.073s-12.325,3.792-18.962-3.16c-2.844-2.844-114.718-146.321-114.718-146.321",
    fill: "none",
    stroke: "#35b8be",
    strokeLinecap: "square",
    strokeMiterlimit: 3,
    strokeWidth: 50,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    stroke: "#35b8be",
    d: "M98.916,188.989a55.306,55.306,0,0,1-12.641-20.858A56.761,56.761,0,0,1,83.747,143.8c.948-17.382,7.9-31.6,21.174-42.98,12.957-11.061,27.81-15.485,44.56-13.905,10.113.632,18.962,3.16,26.862,8.533a56.549,56.549,0,0,1,15.169,12.325l67,77.427",
    fill: "none",
    transform: "translate(82.06 129.405)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 50,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M281.092,297.24,144.251,119m73,246.186L62.4,188.526",
    transform: "translate(36.725 199.394)",
    fill: "none",
    stroke: "#35b8be",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    strokeWidth: 50,
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/mainLogo.0ef7ccc3feaf66f7b625aee98223e5eb.svg";
export { ForwardRef as ReactComponent };